query TagsChartData {
  kpiTags {
    nodes {
      title
      amount
      linkSearchValue
    }
  }
}
